var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3751 12.8836L10.3651 18.4999L12.9021 18.5L12.912 12.8837H14.9211C15.1018 12.8837 15.254 12.7531 15.2752 12.5799L15.4975 10.7695C15.5226 10.5648 15.3569 10.3847 15.1434 10.3847H12.9021V8.8703C12.9021 8.18352 13.0996 7.71553 14.1196 7.71553L15.0641 7.71511C15.2609 7.715 15.4205 7.5609 15.4205 7.37081V5.8443C15.4205 5.65414 15.2608 5.5 15.0639 5.5H13.5248C11.6492 5.5 10.3651 6.60536 10.3651 8.63539V10.3847H8.8566C8.65913 10.3847 8.49925 10.5396 8.5 10.7303L8.50725 12.5406C8.50801 12.7303 8.66741 12.8836 8.86381 12.8836H10.3751Z","fill":"currentColor"}));
}

Facebook.defaultProps = {"viewBox":"4 4 16 16","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
